import { createAsyncThunk } from "@reduxjs/toolkit";
import { imagenAPIs } from "services/api/publisher/imagenAPIs";
import { handleApiError } from "utils/errorHandler";

export const initiateImagenAuth = createAsyncThunk("imagen/initiateImagenAuth", async (payload) => {
  try {
    const response = await imagenAPIs.initiateImagenAuth(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw handleApiError(error);
  }
});

export const createImagenCredentials = createAsyncThunk("imagen/createImagenCredentials", async (payload) => {
  try {
    const response = await imagenAPIs.createImagenCredentials(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw handleApiError(error);
  }
});

export const getImagenCredentials = createAsyncThunk("imagen/getImagenCredentials", async (payload) => {
  try {
    const response = await imagenAPIs.getImagenCredentials(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw handleApiError(error);
  }
});

export const imagenPublish = createAsyncThunk("imagen/imagenPublish", async (payload) => {
  try {
    const response = await imagenAPIs.imagenPublish(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw handleApiError(error);
  }
});

export const disconnectImagenIntegration = createAsyncThunk("imagen/disconnectImagenIntegration", async (payload) => {
  try {
    const response = await imagenAPIs.disconnectImagenIntegration(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw handleApiError(error);
  }
});
